(() => {
  const selector = ".shopify-section-list-videos-page #filterContent";

  function initialize(filter) {
    if (filter.dataset.backdropCloseInitialized === "true") return;
    filter.dataset.backdropCloseInitialized = "true";

    const scrollContainer = filter.querySelector(".popup-content-inner");
    let closeTimer;
    let wasOpen = filter.classList.contains("active");

    const closeDrawer = () => {
      if (
        !filter.classList.contains("active") ||
        filter.classList.contains("is-closing")
      ) {
        return;
      }

      window.clearTimeout(closeTimer);
      filter.classList.add("is-closing");
      closeTimer = window.setTimeout(() => {
        filter.classList.remove("active", "is-closing");
      }, 200);
    };

    filter.requestClose = closeDrawer;

    new MutationObserver(() => {
      const isOpen = filter.classList.contains("active");
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;

      document.body.classList.toggle("overflow-hidden", isOpen);
      if (isOpen) {
        window.requestAnimationFrame(() => {
          if (scrollContainer) scrollContainer.scrollTop = 0;
          filter.scrollTop = 0;
        });
      }
    }).observe(filter, { attributes: true, attributeFilter: ["class"] });

    filter.addEventListener(
      "click",
      (event) => {
        if (
          event.target !== filter &&
          !event.target.closest(".btn-popup-close")
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        closeDrawer();
      },
      true,
    );
  }

  function initializeAll(root = document) {
    if (root.matches?.(selector)) initialize(root);
    root.querySelectorAll?.(selector).forEach(initialize);
  }

  initializeAll();
  document.addEventListener("shopify:section:load", (event) =>
    initializeAll(event.target),
  );
})();
